import { ReactNode } from "react";

import tokens from "../../../theme/tokens";
import {
  CheckCircleIcon,
  CrossCircleIcon,
  CrossIcon,
  ExclamationIcon,
} from "../../atoms/Icons";
import * as s from "./styles";
import type { ToastVariant } from "./index";

interface CustomToastProps {
  title: string | ReactNode;
  description?: string | ReactNode;
  variant: ToastVariant;
  closeToast?: () => void;
}

export default function CustomToast({
  title,
  description,
  variant,
  closeToast,
}: CustomToastProps) {
  const containerStyles = s.container(variant);

  const getIcon = () => {
    switch (variant) {
      case "success":
        return <CheckCircleIcon />;
      case "warning":
        return <ExclamationIcon variant="triangle" />;
      case "error":
        return <CrossCircleIcon />;
      case "info":
      case "default":
      default:
        return <ExclamationIcon variant="circle" />;
    }
  };

  return (
    <div className={containerStyles.toast}>
      <div className={containerStyles.body}>
        {getIcon() && (
          <div className="mr-2 flex-shrink-0 self-start">{getIcon()}</div>
        )}
        <div className="flex-1 min-w-0 mr-7">
          <div className="font-bold text-neutral-900">{title}</div>
          {description && (
            <div className="mt-1 font-normal text-neutral-700">
              {description}
            </div>
          )}
        </div>

        <button
          onClick={closeToast}
          className={s.closeButton}
          aria-label="Close notification"
        >
          <CrossIcon color={tokens.colors["neutral"][900]} size={16} />
        </button>
      </div>
    </div>
  );
}
